import { AccountingBook } from "./accounting-book";
import { CashTransfer } from "./cash-transfer";
import { JournalEntryDetail } from "./journal-entry-detail";
import { SystemField } from "./system-field";

export class GeneralLedger extends SystemField { 
     module?:string;
     batch_number?:string;
     
     transaction_date?:string;
     orig_gl_id?:string;
     is_reverse?:number;
     status?:string;
     comments?:string;
     note?:string;
     ledger_id?:string;
     cash_transfer_id?:string;
     link_original_batch?:string;
     release_date?:string;
     branch_id?:string;
     
     //formula fields
     total_credit?:number;
     total_debit?:number;
     fin_period?:string;

     //relationship
     accounting_book?:AccountingBook;
     cash_transaction?:CashTransfer;
     original_batch?:GeneralLedger;

     journal_details?:JournalEntryDetail[];
     gl_details?:JournalEntryDetail[];
     details?:JournalEntryDetail[];
}
